import ConcernReportedModal from './concern-reported-modal';

export default ConcernReportedModal;
